export default __webpack_public_path__ + "static/media/Delete.d9180b84.svg";